import { Location } from "app/location/location.model";
import { Client } from "app/client/client.model";
import { ClientPotentialMapper } from "./client-potential.mapper";

export class ClientPotential {
  constructor(
    public id: number,
    public client: Client,
    public transportType: string,
    public loadType: string,
    public volume: number,
    public unitType: string,
    public originCountry: string,
    public originLocation: Location,
    public destinationCountry: string,
    public destinationLocation: Location,
    public comment: string,
  ) {}

  public getId(): number {
    return this.id;
  }

  public setId(param: number) {
    this.id = param;
  }

  public getClient(): Client {
    return this.client;
  }

  public getRequestParams() {
    return {
      transportType: this.transportType,
      loadType: this.loadType,
      volume: this.volume,
      unitType: this.unitType,
      originCountry: this.originCountry,
      originLocation: this.originLocation ? this.originLocation.getId() : null,
      destinationCountry: this.destinationCountry,
      destinationLocation: this.destinationLocation
        ? this.destinationLocation.getId()
        : null,
      comment: this.comment,
    };
  }

  public isValid(): boolean {
    return (
      !!this.transportType &&
      !!this.loadType &&
      !!this.volume &&
      !!this.unitType &&
      !!this.originCountry &&
      !!this.destinationCountry
    );
  }

  public getClone(): ClientPotential {
    return ClientPotentialMapper.map({
      id: this.getId(),
      client: this.client,
      transportType: this.transportType,
      loadType: this.loadType,
      volume: this.volume,
      unitType: this.unitType,
      originCountry: this.originCountry,
      originLocation: this.originLocation,
      destinationCountry: this.destinationCountry,
      destinationLocation: this.destinationLocation,
      comment: this.comment,
    });
  }
}
